import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { 
  SettingsInputComponent, 
  SettingsInputComponentOutlined, 
  RadioButtonChecked, 
  RadioButtonUnchecked 
} from '@mui/icons-material';
import { useSocketStatus } from '../hooks/useSocketStatus';

export const SocketStatusIndicator: React.FC = () => {
  const { isConnected, isSubscribed } = useSocketStatus();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 8,
        right: 8,
        zIndex: 1000,
        display: 'flex',
        gap: 1,
        flexDirection: 'row',
        alignItems: 'center'
      }}
    >
      {/* Connection Status */}
      <Tooltip 
        title={
          isConnected 
            ? 'WebSocket connected' 
            : 'WebSocket disconnected - Real-time updates unavailable'
        }
        arrow
      >
        <Chip
          icon={isConnected ? <SettingsInputComponent /> : <SettingsInputComponentOutlined />}
          label={isConnected ? 'Connected' : 'Disconnected'}
          color={isConnected ? 'success' : 'error'}
          size="small"
          variant="outlined"
          sx={{
            backgroundColor: isConnected 
              ? 'rgba(76, 175, 80, 0.1)' 
              : 'rgba(244, 67, 54, 0.1)',
            borderColor: isConnected ? 'success.main' : 'error.main',
            '& .MuiChip-icon': {
              color: isConnected ? 'success.main' : 'error.main'
            }
          }}
        />
      </Tooltip>

      {/* Subscription Status - Always show, grayed out until subscribed */}
      <Tooltip
        title={
          isSubscribed
            ? 'Subscribed to conversation - Real-time updates active'
            : 'Not subscribed - Real-time updates unavailable'
        }
        arrow
      >
        <Chip
          icon={isSubscribed ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
          label={isSubscribed ? 'Subscribed' : 'Not Subscribed'}
          color={isSubscribed ? 'primary' : 'default'}
          size="small"
          variant="outlined"
          disabled={!isSubscribed}
          sx={{
            backgroundColor: isSubscribed
              ? 'rgba(25, 118, 210, 0.1)'
              : 'rgba(158, 158, 158, 0.1)',
            borderColor: isSubscribed ? 'primary.main' : 'rgba(158, 158, 158, 0.5)',
            opacity: isSubscribed ? 1 : 0.5,
            '& .MuiChip-icon': {
              color: isSubscribed ? 'primary.main' : 'rgba(158, 158, 158, 0.7)'
            },
            '&.Mui-disabled': {
              opacity: 0.5
            }
          }}
        />
      </Tooltip>
    </Box>
  );
};

